import { useState, useEffect } from 'react';
import { EmployeeCountT, FundingRoundT } from "ui-io/company-io";
import { formatLargeNumber } from "ui-lib";

export { TABS } from "./constants";

export const reloadPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};
export const calculateFundingAmount = (fundingArray:FundingRoundT[]) => {
  return formatLargeNumber(fundingArray.reduce((total, entry) => total + entry.amount, 0));
};
export const getLatestEmployeeCount = (empArray:EmployeeCountT[]) => {
  const latestRecord = empArray.reduce((latest, current) => 
        parseInt(current.year) > parseInt(latest.year) ? current : latest
    );
    return latestRecord.count.to;
};
export const getInvestorCount = (fundingArray:FundingRoundT[]) => {
    const uniqueInvestors = new Set(fundingArray.flatMap(entry => entry.investorIDs));
    return uniqueInvestors.size;
};


const getPublicKey = (): string | null => {
  if (typeof window !== "undefined") {
    const globalWindow = window as typeof window & {
      PUBLIC_KEY?: string;
      publicKey?: string;
      JSEncrypt?: new () => { setPublicKey: (key: string) => void; encrypt: (value: string) => string };
    };

    return (
      globalWindow.PUBLIC_KEY ||
      globalWindow.publicKey ||
      (typeof process !== "undefined" && process.env
        ? process.env.REACT_APP_PUBLIC_KEY || process.env.PUBLIC_KEY || null
        : null) ||
      null
    );
  }

  return typeof process !== "undefined" && process.env
    ? process.env.REACT_APP_PUBLIC_KEY || process.env.PUBLIC_KEY || null
    : null;
};

export const getEncryptedPassword = ({ password }: { password: string }): string | false => {
    if (!password || password.trim() === '') {
      return false;
    }

    const publicKey = getPublicKey();
    if (!publicKey) {
      return password;
    }

    const JSEncryptCtor = (typeof window !== "undefined" ? (window as any).JSEncrypt : undefined) || (globalThis as any).JSEncrypt;
    if (!JSEncryptCtor) {
      return password;
    }

    const encryptor = new JSEncryptCtor();
    encryptor.setPublicKey(publicKey);
    const encrypted = encryptor.encrypt(password);
    return encrypted || password;
};

export const decodeJWT = (token: string) => {
  try {
    if (!token || typeof token !== 'string' || token.split('.').length !== 3) {
      return null;
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
      return JSON.parse(jsonPayload);
    } catch (err) {
      return null;
    }
};

